const m = require('air-vue-model')()
m.url = 'outlet_nomenclature'
m.name = 'outletNomenclature'


m.setPagination({
    page_size: 'all'
})

module.exports = m